(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-buyer-protection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buyer-protection-carousel-v3')) {
    customElements.define('buyer-protection-carousel-v3', class extends HTMLElement {
      connectedCallback() {
        this.panel = this.closest('.ekko-buyer-protection');
        if (!this.panel || this.panel.dataset.layout !== 'carousel') return;

        this.track = this.querySelector('[data-buyer-protection-track]');
        // Navigation lives in the panel header, outside this custom element.
        // Query from the panel so the controls receive their click handlers.
        this.controls = this.panel.querySelector('[data-buyer-protection-controls]');
        this.previous = this.panel.querySelector('[data-buyer-protection-previous]');
        this.next = this.panel.querySelector('[data-buyer-protection-next]');
        this.progress = this.querySelector('[data-buyer-protection-progress]');
        this.progressValue = this.querySelector('[data-buyer-protection-progress-value]');
        this.status = this.querySelector('[data-buyer-protection-status]');
        if (!this.track) return;

        this.items = Array.from(this.track.children);
        this.loop = this.panel.dataset.carouselLoop === 'true';
        this.autoplay = this.panel.dataset.carouselAutoplay === 'true';
        this.speed = Math.max(3000, Number(this.panel.dataset.carouselSpeed) || 5000);
        this.desktopItems = this.panel.dataset.carouselDesktopItems || 'auto';
        this.mobileItems = this.panel.dataset.carouselMobileItems || 'auto';
        this.scrollAmount = this.panel.dataset.carouselScrollAmount || 'item';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rtl = getComputedStyle(this.track).direction === 'rtl';

        this.handlePrevious = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.handleScroll = () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        };
        this.handlePointerEnter = () => this.stopAutoplay();
        this.handlePointerLeave = () => this.startAutoplay();
        this.handleFocusIn = () => this.stopAutoplay();
        this.handleFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.startAutoplay();
        };
        this.handleVisibility = () => document.hidden ? this.stopAutoplay() : this.startAutoplay();
        this.previous?.addEventListener('click', this.handlePrevious);
        this.next?.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.addEventListener('pointerenter', this.handlePointerEnter);
        this.addEventListener('pointerleave', this.handlePointerLeave);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('focusout', this.handleFocusOut);
        document.addEventListener('visibilitychange', this.handleVisibility);

        this.resizeObserver = new ResizeObserver(() => {
          this.applyLayout();
          this.update();
        });
        this.resizeObserver.observe(this.track);
        requestAnimationFrame(() => {
          this.applyLayout();
          this.update();
          this.startAutoplay();
        });
      }

      disconnectedCallback() {
        this.stopAutoplay();
        cancelAnimationFrame(this.scrollFrame);
        this.resizeObserver?.disconnect();
        this.previous?.removeEventListener('click', this.handlePrevious);
        this.next?.removeEventListener('click', this.handleNext);
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.removeEventListener('pointerenter', this.handlePointerEnter);
        this.removeEventListener('pointerleave', this.handlePointerLeave);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      get maxIndex() {
        return Math.max(0, (this.items?.length || 0) - (this.visibleItems || 1));
      }

      getLayoutItems() {
        if (!this.track || !this.items?.length) return 1;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const configured = isMobile ? this.mobileItems : this.desktopItems;
        let count = Number.parseInt(configured, 10);

        if (!Number.isFinite(count)) {
          const width = this.track.clientWidth;
          const isCards = this.panel.classList.contains('ekko-buyer-protection--style-cards');
          if (isCards && isMobile) count = this.items.length > 1 ? 1.16 : 1;
          else if (isCards) count = width >= 500 ? 2 : 1;
          else if (isMobile) count = this.items.length > 1 ? 2 : 1;
          else if (width >= 480) count = 3;
          else if (width >= 320) count = 2;
          else count = 1;
        }

        return Math.min(Math.max(count, 1), this.items.length);
      }

      applyLayout() {
        if (!this.track || !this.items?.length || this.track.clientWidth <= 0) return;
        const anchorIndex = Math.min(this.currentIndex, this.maxIndex);
        this.layoutItems = this.getLayoutItems();
        this.visibleItems = Math.max(1, Math.floor(this.layoutItems));
        const styles = getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const width = (this.track.clientWidth - gap * (this.layoutItems - 1)) / this.layoutItems;
        this.track.style.setProperty('--buyer-protection-item-width', `${Math.max(1, width)}px`);

        requestAnimationFrame(() => {
          this.scrollToItem(Math.min(anchorIndex, this.maxIndex), false);
          this.update();
        });
      }

      get currentIndex() {
        if (!this.track || !this.items?.length) return 0;
        const trackRect = this.track.getBoundingClientRect();
        let nearest = 0;
        let distance = Number.POSITIVE_INFINITY;

        this.items.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const itemDistance = this.rtl
            ? Math.abs(rect.right - trackRect.right)
            : Math.abs(rect.left - trackRect.left);
          if (itemDistance < distance) {
            nearest = index;
            distance = itemDistance;
          }
        });
        return Math.min(nearest, this.maxIndex);
      }

      move(direction) {
        if (!this.items?.length) return;
        const step = this.scrollAmount === 'page' ? this.visibleItems : 1;
        let target = this.currentIndex + (direction * step);
        if (this.loop && target > this.maxIndex) target = 0;
        else if (this.loop && target < 0) target = this.maxIndex;
        else target = Math.min(Math.max(target, 0), this.maxIndex);
        this.scrollToItem(target, true);
        this.restartAutoplay();
      }

      scrollToItem(index, smooth) {
        if (!this.track || !this.items?.length) return;
        const targetIndex = Math.min(Math.max(index, 0), this.maxIndex);
        const item = this.items[targetIndex];
        if (!item) return;

        const trackRect = this.track.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const distance = this.rtl
          ? itemRect.right - trackRect.right
          : itemRect.left - trackRect.left;

        this.track.scrollBy({
          left: distance,
          behavior: smooth && !this.reduceMotion ? 'smooth' : 'auto'
        });
      }

      update() {
        if (!this.track) return;
        const overflowing = this.maxIndex > 0 && this.track.scrollWidth > this.track.clientWidth + 2;
        const index = this.currentIndex;
        this.overflowing = overflowing;

        if (this.controls) this.controls.hidden = !overflowing;
        if (this.previous) this.previous.disabled = !this.loop && index <= 0;
        if (this.next) this.next.disabled = !this.loop && index >= this.maxIndex;

        if (this.progress && this.progressValue) {
          this.progress.hidden = !overflowing;
          const size = Math.min(100, (this.visibleItems / this.items.length) * 100);
          const offset = this.maxIndex > 0 ? (index / this.maxIndex) * (100 - size) : 0;
          this.progressValue.style.width = `${size}%`;
          if (this.rtl) {
            this.progressValue.style.right = `${offset}%`;
            this.progressValue.style.left = 'auto';
          }
          else {
            this.progressValue.style.left = `${offset}%`;
            this.progressValue.style.right = 'auto';
          }
        }

        if (this.status) {
          const end = Math.min(index + this.visibleItems, this.items.length);
          this.status.textContent = `${index + 1}–${end} / ${this.items.length}`;
        }
        if (!overflowing) this.stopAutoplay();
      }

      startAutoplay() {
        if (!this.autoplay || !this.overflowing || this.reduceMotion || document.hidden) return;
        if (!this.loop && this.currentIndex >= this.maxIndex) return;
        this.stopAutoplay();
        this.autoplayTimer = window.setTimeout(() => {
          this.move(1);
          this.startAutoplay();
        }, this.speed);
      }

      stopAutoplay() {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = undefined;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-coupon-pack"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-coupon-pack')) {
    customElements.define('product-coupon-pack', class ProductCouponPack extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.drawer = document.getElementById(this.dataset.drawerId);
        const signal = this.abortController.signal;

        this.drawer?.addEventListener('click', this.handleCopy, { signal });
        this.drawer?.addEventListener('drawer:afterHide', this.handleDrawerAfterHide, { signal });
        document.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });

        this.updateAvailability();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        if (this.drawer?.open) this.drawer.hide();
        if (this.drawer?.parentElement === document.body) this.appendChild(this.drawer);
      }

      get parentBlock() {
        return this.closest('.shopify-block');
      }

      get status() {
        return this.drawer?.querySelector('[data-coupon-pack-status]');
      }

      getCouponItem(target) {
        const item = target.closest?.('[data-coupon-pack-item]');
        if (item) return item;
        return target.querySelector?.(':scope > [data-coupon-pack-item]') || null;
      }

      getSelectedBlockId(event) {
        if (event.detail?.blockId) return event.detail.blockId;

        const wrapper = event.target?.closest?.('[id^="shopify-block-"]');
        return wrapper?.id?.replace(/^shopify-block-/, '') || '';
      }

      updateAvailability() {
        if (!this.drawer) return;
        const country = (this.dataset.countryCode || '').toUpperCase();

        this.drawer.querySelectorAll('[data-coupon-pack-item]').forEach((item) => {
          const countries = (item.dataset.countries || '')
            .split(',')
            .map((code) => code.trim().toUpperCase())
            .filter(Boolean);
          const countryAllowed = countries.length === 0 || countries.includes(country);
          const expiry = this.parseExpiry(item.dataset.expiresAt);
          const expired = expiry !== null && expiry.getTime() < Date.now();
          const button = item.querySelector('[data-coupon-copy]');
          const unavailable = !countryAllowed || !button?.dataset.copyCode;

          item.dataset.unavailable = unavailable ? 'true' : 'false';
          item.dataset.expired = expired ? 'true' : 'false';

          if (!button) return;
          button.disabled = unavailable || expired;
          const label = expired
            ? button.dataset.expiredLabel
            : unavailable
              ? button.dataset.unavailableLabel
              : button.dataset.defaultLabel;
          this.setButtonLabel(button, label);
        });

        const availableCount = Array.from(this.drawer.querySelectorAll('[data-coupon-pack-item]'))
          .filter((item) => item.dataset.unavailable !== 'true' && item.dataset.expired !== 'true').length;
        const count = this.querySelector('[data-coupon-count]');
        if (count) count.textContent = availableCount;
      }

      parseExpiry(value) {
        if (!value) return null;
        const normalized = /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T23:59:59` : value;
        const date = new Date(normalized);
        return Number.isNaN(date.getTime()) ? null : date;
      }

      handleCopy = async (event) => {
        const button = event.target.closest('[data-coupon-copy]');
        if (!button || button.disabled) return;

        const code = button.dataset.copyCode;
        if (!code) return;

        button.disabled = true;
        try {
          await this.copyText(code);
          button.dataset.copied = 'true';
          this.setButtonLabel(button, button.dataset.copiedLabel);
          if (this.status) this.status.textContent = this.dataset.copyMessage;

          window.clearTimeout(button.copyResetTimer);
          button.copyResetTimer = window.setTimeout(() => {
            button.dataset.copied = 'false';
            button.disabled = false;
            this.setButtonLabel(button, button.dataset.copyAgainLabel || button.dataset.defaultLabel);
            if (this.status) this.status.textContent = '';
          }, 2400);
        }
        catch (error) {
          button.disabled = false;
          if (this.status) this.status.textContent = button.dataset.errorLabel;
        }
      };

      async copyText(text) {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
          return;
        }

        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();
        if (!copied) throw new Error('Copy failed');
      }

      setButtonLabel(button, label) {
        const text = button.querySelector('[data-coupon-copy-text]');
        if (text) text.textContent = label || '';
      }

      handleBlockSelect = (event) => {
        const drawer = this.drawer || document.getElementById(this.dataset.drawerId);
        if (!drawer) return;

        const selectedBlockId = this.getSelectedBlockId(event);
        if (selectedBlockId === this.dataset.parentBlockId) {
          if (drawer.open) drawer.hide();
          return;
        }

        const selectedItem = this.getCouponItem(event.target);
        if (selectedItem && drawer.contains(selectedItem)) {
          if (!drawer.open) drawer.show(null, false);
          selectedItem.scrollIntoView({ block: 'nearest' });
          return;
        }

        if (event.target === this.parentBlock && drawer.open) drawer.hide();
      };

      handleDrawerAfterHide = () => {
        if (!Shopify.designMode || !this.drawer || this.drawer.parentElement !== document.body) return;
        this.appendChild(this.drawer);
      };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-coupon')) {
    customElements.define('product-coupon', class ProductCoupon extends HTMLElement {
      static storageKey = 'ekko:selected-coupons:v1';
      static mutationQueue = Promise.resolve();

      connectedCallback() {
        // Storefront content must never depend on JavaScript completing. Mark the
        // component visible first, then progressively enhance it.
        this.setAttribute('data-ready', '');
        this.abortController?.abort();
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.offers = Array.from(this.querySelectorAll('[data-coupon-offer]'));
        this.statusElement = this.querySelector('[data-coupon-status]');
        this.variant = {
          id: String(this.dataset.variantId || ''),
          title: String(this.dataset.variantTitle || '')
        };

        if (!this.offers.length) return;

        try {
          this.addEventListener('change', this.handleChange, { signal });
          document.addEventListener('ekko:coupon-selection-change', this.handleExternalSelection, { signal });

          const pubsub = window.theme?.pubsub;
          const variantChangeEvent = pubsub?.PUB_SUB_EVENTS?.variantChange;
          if (typeof pubsub?.subscribe === 'function' && variantChangeEvent) {
            this.variantChangeUnsubscriber = pubsub.subscribe(variantChangeEvent, this.handleVariantChange);
          }

          this.initializeExpiries();
          const pruned = this.pruneStoredSelections();
          this.refreshEligibility(false);
          this.updateCountdowns();
          this.countdownTimer = window.setInterval(() => this.updateCountdowns(), 1000);

          if (pruned) this.queueDiscountUpdate(this.getStoredSelections()).catch(() => {});
        } catch (error) {
          // Keep the server-rendered offer usable and visible if an optional theme
          // integration is unavailable. This also prevents one malformed child
          // block from taking the entire coupon group down.
          console.error('[Ekko product coupon] Initialization failed.', error);
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.variantChangeUnsubscriber?.();
        window.clearInterval(this.countdownTimer);
      }

      get countryCode() {
        return String(this.dataset.countryCode || '').toUpperCase();
      }

      get selectionMode() {
        return this.dataset.selectionMode === 'multiple' ? 'multiple' : 'single';
      }

      getStoredSelections() {
        try {
          const value = JSON.parse(localStorage.getItem(ProductCoupon.storageKey) || '[]');
          return Array.isArray(value) ? value.filter((entry) => entry?.code) : [];
        } catch (error) {
          return [];
        }
      }

      setStoredSelections(entries) {
        try {
          localStorage.setItem(ProductCoupon.storageKey, JSON.stringify(entries));
        } catch (error) {
          // The coupon still works for the current page when storage is unavailable.
        }
      }

      normalizeTokens(value) {
        return String(value || '')
          .split(/[\n,;|]+/)
          .map((token) => token.trim().toLowerCase())
          .filter(Boolean);
      }

      initializeExpiries() {
        this.offers.forEach((offer) => {
          const mode = offer.dataset.countdownMode;
          let expiry = 0;

          if (mode === 'fixed') {
            expiry = Date.parse(offer.dataset.endsAt || '') || 0;
          } else if (mode === 'evergreen') {
            const key = `ekko:coupon-expiry:${offer.dataset.offerId}:${this.countryCode}`;
            try {
              expiry = Number(localStorage.getItem(key)) || 0;
              if (!expiry) {
                expiry = Date.now() + Number(offer.dataset.durationMinutes || 0) * 60000;
                if (expiry > Date.now()) localStorage.setItem(key, String(expiry));
              }
            } catch (error) {
              expiry = Date.now() + Number(offer.dataset.durationMinutes || 0) * 60000;
            }
          }

          offer.dataset.expiry = expiry > 0 ? String(expiry) : '';
        });
      }

      pruneStoredSelections() {
        const now = Date.now();
        const before = this.getStoredSelections();
        const after = before.filter((entry) => {
          if (entry.country && entry.country !== this.countryCode) return false;
          if (entry.expiresAt && Number(entry.expiresAt) <= now) return false;
          return true;
        });

        if (after.length === before.length) return false;
        this.setStoredSelections(after);
        return true;
      }

      isCountryEligible(offer) {
        const rule = offer.dataset.countryRule || 'all';
        if (rule === 'all') return true;

        const codes = this.normalizeTokens(offer.dataset.countryCodes).map((code) => code.toUpperCase());
        const matched = codes.includes(this.countryCode);
        return rule === 'include' ? matched : !matched;
      }

      isVariantEligible(offer) {
        const rule = offer.dataset.variantRule || 'all';
        if (rule === 'all') return true;

        const values = this.normalizeTokens(offer.dataset.variantValues);
        const matched = values.includes(this.variant.id.toLowerCase()) || values.includes(this.variant.title.toLowerCase());
        return rule === 'include' ? matched : !matched;
      }

      isExpired(offer) {
        const expiry = Number(offer.dataset.expiry || 0);
        return expiry > 0 && expiry <= Date.now();
      }

      getEligibility(offer) {
        if (!offer.dataset.code) return { eligible: false, reason: offer.dataset.setupText };
        if (this.isExpired(offer)) return { eligible: false, reason: offer.dataset.expiredText };
        if (!this.isCountryEligible(offer)) return { eligible: false, reason: offer.dataset.countryUnavailableText };
        if (!this.isVariantEligible(offer)) return { eligible: false, reason: offer.dataset.variantUnavailableText };
        return { eligible: true, reason: '' };
      }

      refreshEligibility(updateCartWhenSelectionChanges = true) {
        const stored = this.getStoredSelections();
        const selectedCodes = new Set(stored.map((entry) => String(entry.code).toLowerCase()));
        const invalidSelectedCodes = new Set();

        this.offers.forEach((offer) => {
          const input = offer.querySelector('[data-coupon-input]');
          const copy = offer.querySelector('[data-coupon-copy]');
          const reason = offer.querySelector('[data-coupon-reason]');
          if (!input || !copy || !reason) return;

          const eligibility = this.getEligibility(offer);
          const code = String(offer.dataset.code || '').toLowerCase();
          const selected = eligibility.eligible && selectedCodes.has(code);

          if (!eligibility.eligible && selectedCodes.has(code)) invalidSelectedCodes.add(code);

          offer.dataset.eligible = String(eligibility.eligible);
          offer.dataset.selected = String(selected);
          input.disabled = !eligibility.eligible || this.hasAttribute('aria-busy');
          input.checked = selected;
          copy.textContent = selected ? offer.dataset.appliedText : offer.dataset.applyText;
          reason.textContent = eligibility.reason;
          reason.hidden = eligibility.eligible || !eligibility.reason;

          const shouldHide = !eligibility.eligible && this.dataset.hideIneligible === 'true' && !window.Shopify?.designMode;
          offer.closest('.ekko-product-coupon__entry')?.toggleAttribute('hidden', shouldHide);
        });

        if (invalidSelectedCodes.size > 0) {
          const next = stored.filter((entry) => !invalidSelectedCodes.has(String(entry.code).toLowerCase()));
          this.setStoredSelections(next);
          if (updateCartWhenSelectionChanges) this.queueDiscountUpdate(next).catch(() => {});
        }
      }

      updateCountdowns() {
        let expiredSelection = false;
        const storedCodes = new Set(this.getStoredSelections().map((entry) => String(entry.code).toLowerCase()));

        this.offers.forEach((offer) => {
          const timer = offer.querySelector('[data-coupon-timer]');
          const timerValue = timer?.querySelector('[data-coupon-timer-value]');
          const divider = offer.querySelector('[data-coupon-divider]');
          const expiry = Number(offer.dataset.expiry || 0);
          if (!timer || !timerValue || !expiry) {
            if (timer) timer.hidden = true;
            if (divider) divider.hidden = true;
            offer.dataset.hasCountdown = 'false';
            return;
          }

          const remaining = Math.max(0, expiry - Date.now());
          const totalSeconds = Math.floor(remaining / 1000);
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          const time = [hours, minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':');

          timer.hidden = false;
          if (divider) divider.hidden = false;
          offer.dataset.hasCountdown = 'true';
          timerValue.textContent = days > 0 ? `${days}${window.theme?.dateStrings?.d || 'd'} ${time}` : time;
          timer.dateTime = new Date(expiry).toISOString();

          if (remaining === 0 && offer.dataset.expiredHandled !== 'true') {
            offer.dataset.expiredHandled = 'true';
            if (storedCodes.has(String(offer.dataset.code).toLowerCase())) expiredSelection = true;
          }
        });

        if (expiredSelection) {
          const now = Date.now();
          const next = this.getStoredSelections().filter((entry) => !entry.expiresAt || Number(entry.expiresAt) > now);
          this.setStoredSelections(next);
          this.refreshEligibility(false);
          this.queueDiscountUpdate(next).catch(() => {});
        } else {
          this.refreshEligibility(false);
        }
      }

      handleVariantChange = (event) => {
        const data = event?.data;
        if (!data || String(data.productId) !== String(this.dataset.productId)) return;
        if (String(data.sectionId) !== String(this.dataset.sectionId)) return;

        this.variant = {
          id: String(data.variant?.id || ''),
          title: String(data.variant?.title || '')
        };
        this.refreshEligibility(true);
      };

      handleExternalSelection = (event) => {
        if (event.detail?.source === this) return;
        this.refreshEligibility(false);
      };

      handleChange = async (event) => {
        const input = event.target instanceof Element
          ? event.target.closest('[data-coupon-input]')
          : null;
        if (!input || input.disabled || this.hasAttribute('aria-busy')) return;

        const offer = input.closest('[data-coupon-offer]');
        if (!offer) return;

        const previous = this.getStoredSelections();
        const code = offer.dataset.code;
        let next = previous.filter((entry) => String(entry.code).toLowerCase() !== String(code).toLowerCase());

        if (input.checked) {
          if (this.selectionMode === 'single') next = [];
          next.push({
            code,
            country: this.countryCode,
            expiresAt: Number(offer.dataset.expiry || 0),
            productId: this.dataset.productId,
            offerId: offer.dataset.offerId
          });
        }

        this.setStoredSelections(next);
        this.refreshEligibility(false);
        this.setBusy(true);
        this.showStatus(this.dataset.applyingMessage, false);

        try {
          await this.queueDiscountUpdate(next);
          this.showStatus(input.checked ? this.dataset.appliedMessage : this.dataset.removedMessage, false);
          document.dispatchEvent(new CustomEvent('ekko:coupon-selection-change', {
            detail: { source: this, selections: next }
          }));
        } catch (error) {
          this.setStoredSelections(previous);
          this.refreshEligibility(false);
          this.showStatus(error?.message || this.dataset.errorMessage, true);
        } finally {
          this.setBusy(false);
        }
      };

      setBusy(busy) {
        this.toggleAttribute('aria-busy', busy);
        this.querySelectorAll('[data-coupon-input]').forEach((input) => {
          if (busy) {
            input.dataset.wasDisabled = String(input.disabled);
            input.disabled = true;
          } else {
            input.disabled = input.dataset.wasDisabled === 'true';
            delete input.dataset.wasDisabled;
          }
        });
      }

      showStatus(message, error) {
        if (!this.statusElement) return;
        this.statusElement.textContent = message || '';
        this.statusElement.classList.toggle('sr-only', !error);
      }

      queueDiscountUpdate(selections) {
        ProductCoupon.mutationQueue = ProductCoupon.mutationQueue
          .catch(() => {})
          .then(() => this.updateCartDiscounts(selections));
        return ProductCoupon.mutationQueue;
      }

      async waitForCartMutation() {
        window.theme = window.theme || {};
        window.theme.cartMutationState = window.theme.cartMutationState || { inFlight: false };
        const startedAt = Date.now();
        while (window.theme.cartMutationState.inFlight) {
          if (Date.now() - startedAt > 8000) throw new Error(this.dataset.errorMessage);
          await new Promise((resolve) => window.setTimeout(resolve, 80));
        }
      }

      async updateCartDiscounts(selections) {
        await this.waitForCartMutation();
        if (!window.theme?.routes?.cart_update_url || !window.theme?.utils?.fetchConfig || !window.theme?.utils?.parseJsonResponse || !window.theme?.utils?.cartStateFromResponse) {
          throw new Error(this.dataset.errorMessage);
        }
        window.theme.cartMutationState.inFlight = true;

        try {
          let sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
            bubbles: true,
            detail: { sections }
          }));
          sections = [...new Set(sections.filter(Boolean))];

          const codes = [...new Set(selections.map((entry) => entry.code).filter(Boolean))];
          const response = await fetch(window.theme.routes.cart_update_url, {
            ...window.theme.utils.fetchConfig(),
            body: JSON.stringify({
              discount: codes.join(','),
              sections,
              sections_url: window.location.pathname
            })
          });
          const parsedState = await window.theme.utils.parseJsonResponse(response);
          if (!response.ok) throw new Error(parsedState.description || parsedState.message || this.dataset.errorMessage);

          const cart = window.theme.utils.cartStateFromResponse(parsedState);
          const pubsub = window.theme?.pubsub;
          const cartUpdateEvent = pubsub?.PUB_SUB_EVENTS?.cartUpdate;
          if (typeof pubsub?.publish === 'function' && cartUpdateEvent) {
            try {
              pubsub.publish(cartUpdateEvent, {
                source: 'product-coupon',
                cart
              });
            } catch (renderError) {
              // The discount mutation has already succeeded. Keep the coupon
              // selection and refresh the drawer instead of rolling it back.
              console.error(renderError);
              document.dispatchEvent(new CustomEvent('cart:refresh', {
                detail: { open: false }
              }));
            }
          }
          return cart;
        } finally {
          window.theme.cartMutationState.inFlight = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-share-help')) {
    customElements.define('product-share-help', class ProductShareHelp extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.drawer = document.getElementById(this.dataset.drawerId);
        this.drawer?.addEventListener('drawer:afterHide', this.handleDrawerAfterHide, {
          signal: this.abortController.signal
        });
        document.addEventListener('shopify:block:select', this.handleBlockSelect, {
          signal: this.abortController.signal
        });
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect, {
          signal: this.abortController.signal
        });
        document.addEventListener('shopify:section:deselect', this.handleSectionDeselect, {
          signal: this.abortController.signal
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();

        if (this.drawer?.open) this.drawer.hide();
        if (this.drawer?.parentElement === document.body) this.appendChild(this.drawer);
      }

      get parentBlock() {
        return this.closest(`#shopify-block-${CSS.escape(this.dataset.blockId)}`);
      }

      getHelpItem(target) {
        const closestItem = target.closest?.('[data-product-help-entry]');
        if (closestItem) return closestItem;

        return target.querySelector?.(':scope > [data-product-help-entry]') || null;
      }

      closeDrawer(drawer, immediate = false) {
        if (!drawer.open) {
          if (immediate) drawer.hidden = true;
          return;
        }

        drawer.hide();
        if (immediate) drawer.hidden = true;
      }

      handleBlockSelect = (event) => {
        const drawer = this.drawer || document.getElementById(this.dataset.drawerId);
        const selectedItem = this.getHelpItem(event.target);
        if (!drawer) return;

        if (event.target === this.parentBlock) {
          this.closeDrawer(drawer, true);
          return;
        }

        if (!selectedItem || !drawer.contains(selectedItem)) {
          this.closeDrawer(drawer, true);
          return;
        }

        if (!drawer.open) drawer.show(null, false);
      };

      handleBlockDeselect = (event) => {
        const drawer = this.drawer || document.getElementById(this.dataset.drawerId);
        const deselectedItem = this.getHelpItem(event.target);
        if (!drawer || !deselectedItem || !drawer.contains(deselectedItem)) return;

        this.closeDrawer(drawer);
      };

      handleSectionDeselect = (event) => {
        const drawer = this.drawer || document.getElementById(this.dataset.drawerId);
        const section = this.closest('.shopify-section');
        if (!drawer || !section || event.target !== section) return;

        this.closeDrawer(drawer);
      };

      handleDrawerAfterHide = () => {
        if (!Shopify.designMode || !this.drawer || this.drawer.parentElement !== document.body) return;

        this.appendChild(this.drawer);
      };
    });
  }
  } catch(e) { console.error(e); }
})();

})();
